import { GetRefreshTokenOutputDTO } from '@/api/dtos/auth-service-dto'
import { ACCESS_TOKEN_KEY, TREUUNFE_WEB_SITE_URL } from '@/shared/constants'
import { TokenType } from '@/types'
import { decodeToken } from '@/utils/decode-token'
import axios from 'axios'
import { destroyCookie, parseCookies } from 'nookies'
import { fallbackDomain, setTokenOnCookies } from '../nookies/token'

let isRefreshing = false
let failedRequestsQueue = [] as Array<{
  onSuccess: ({ value }: { value?: any }) => void
  onFailure: ({ reason }: { reason?: any }) => void
}>

const getRedirectToUrl = () => {
  const isProduction = process.env.NEXT_PUBLIC_ENVIRONMENT === 'production'
  const isDevelopment = process.env.NEXT_PUBLIC_ENVIRONMENT === 'development'

  if (isProduction) {
    return TREUUNFE_WEB_SITE_URL
  }

  if (isDevelopment) {
    return 'https://sandbox.treeunfe.com.br/'
  }

  return `https://sandbox.treeunfe.com.br/?returnTo=${window.location.origin}`
}

export const handleSignOut = () => {
  destroyCookie({}, ACCESS_TOKEN_KEY, {
    path: '/',
    domain: fallbackDomain,
  })

  window.location.href = getRedirectToUrl()
}

export const privateClientSetup = (version: string) => {
  const cookies = parseCookies()
  const token = cookies[ACCESS_TOKEN_KEY]

  const api = axios.create({
    baseURL: `${process.env.NEXT_PUBLIC_API_BACKEND}/${version}`,
    headers: {
      'Content-Type': 'application/json',
    },
  })

  api.interceptors.request.use(
    async (config) => {
      const cookies = parseCookies()
      const token = cookies[ACCESS_TOKEN_KEY]
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    },
    (error) => {
      return Promise.reject(error)
    },
  )

  // interceptar respostas
  api.interceptors.response.use(
    (response) => {
      return response
    },
    async (error) => {
      const originalConfig = error.config

      if (
        error.response.status === 401 ||
        error.response?.data?.message === 'Unauthorized'
      ) {
        if (!isRefreshing) {
          isRefreshing = true

          const { userID } = decodeToken(token) as TokenType

          if (!userID) {
            handleSignOut()
          }

          await api
            .get<GetRefreshTokenOutputDTO>(`/auth/refresh_token`)
            .then((response) => {
              const { token: newToken } = response.data.data.meta

              setTokenOnCookies(newToken)

              failedRequestsQueue.forEach((request) =>
                request.onSuccess({ value: newToken }),
              )

              failedRequestsQueue = []
            })
            .catch(() => {
              failedRequestsQueue.forEach((request) => request.onFailure(error))
              failedRequestsQueue = []
              handleSignOut()
            })
            .finally(() => {
              isRefreshing = false
            })
        }

        return new Promise((resolve, reject) => {
          failedRequestsQueue.push({
            onSuccess: () => {
              resolve(api(originalConfig))
            },
            onFailure: (e) => {
              reject(e)
            },
          })
        })
      }
      return Promise.reject(error)
    },
  )
  return api
}
